import { VStack } from "./utils";

const EmptyTableIllustration = ({ text }: { text: string }) => (
  <VStack className="w-full mx-auto">
    <img
      src="/media/icons/emptyFolder.svg"
      className="h-44 my-5 w-56 mx-auto"
      alt="no data"
    />
    <p className="mx-auto text-labelColor ">{text}</p>
  </VStack>
);

export default EmptyTableIllustration;
